import z from 'zod';
import { string } from './zod';
export var LoraDeviceTypes;
(function (LoraDeviceTypes) {
    LoraDeviceTypes["Adeunis"] = "adeunis.arf8123aa";
    LoraDeviceTypes["IoTracker"] = "iotracker.v2";
    LoraDeviceTypes["Milesight"] = "milesight.ws101";
    LoraDeviceTypes["Sensative"] = "sensative.1301001";
})(LoraDeviceTypes || (LoraDeviceTypes = {}));
export const adeunisConfig = z.object({
    fieldTest: string,
});
export const ioTrackerConfig = z.object({
    beaconScan: string,
    gps: string,
    preMandown: string,
    mandown: string,
    movement: string,
    alarmSeverity: string,
    alive: string,
});
export const milesightConfig = z.object({
    beaconScan: string,
    alarmSeverity: string,
    alive: string,
});
export const sensativeConfig = z.object({
    alarmSeverity: string,
    alive: string,
    floodDetected: string,
    noFloodDetected: string,
});
export const anyLoraConfig = z.discriminatedUnion('type', [
    z.object({ type: z.literal(LoraDeviceTypes.Adeunis), config: adeunisConfig }),
    z.object({ type: z.literal(LoraDeviceTypes.IoTracker), config: ioTrackerConfig }),
    z.object({ type: z.literal(LoraDeviceTypes.Milesight), config: milesightConfig }),
    z.object({ type: z.literal(LoraDeviceTypes.Sensative), config: sensativeConfig }),
]);
